var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"a-burger",on:{"click":_vm.onclick}})
}
var staticRenderFns = []

export { render, staticRenderFns }